module.exports = __webpack_public_path__ + "img/slide-3-placeholder.2fe9ac41.png";